<template>
  <component :is="content" class="documentation">
    <template #header>
      <slot name="header" />
    </template>
    <template #footer>
      <slot name="footer" />
    </template>
  </component>
</template>

<script setup lang="ts">
import { shallowRef } from 'vue';
import hydrateHtml from '@/components/markdown/utils/hydrateHtml';
import * as Widgets from '@/components/markdown/widgets';

const props = defineProps({ html: { type: String, required: true }, tag: { type: String, default: 'div' } });
// dynamic component
const content = shallowRef(
  hydrateHtml(
    props.html.replace(/<blockquote(?:\s+[^>]*)?>\s*/g, '<Note>').replace(/<\/blockquote>/g, '</Note>'),
    {
      components: { ...Widgets },
    },
    props.tag
  )
);
</script>
